export const EMPTY_GRAPH_DATA = {
  data: {
    datasets: [],
    labels: [],
  },
};
